import PropTypes from 'prop-types';
import { userPositionList } from 'constants/register';
import { registerFormValidationErrorType } from 'modules/general/enums';
import generalStrings from 'modules/general/strings';
import RadioButtonGroup from 'modules/common/components/RadioButtonGroup';
import SectionDivider from 'modules/common/components/SectionDivider';

import {
  OtherPositionInputLabel,
  OtherPositionInputField,
  FormValidationError,
} from './UserPosition.style';

const UserPosition = ({
  formFieldsValues,
  formFieldsValidation,
  handleTextInputFieldChange,
  handleRadioBtnFieldChange,
}) => {
  const selectedUserPositionObj =
    userPositionList.find(userPosition => userPosition.key === formFieldsValues.userPosition) || {};

  return (
    <>
      <RadioButtonGroup
        RadioButtonGroupArr={userPositionList}
        selectedRadioButton={selectedUserPositionObj}
        handleRadioButtonClick={value => handleRadioBtnFieldChange('userPosition', value)}
      />
      {selectedUserPositionObj.key === 'Other' && (
        <>
          <SectionDivider gap={12} />
          <OtherPositionInputLabel>
            {generalStrings.registerForm.formOtherUserPositionFieldLabel}
          </OtherPositionInputLabel>
          <SectionDivider gap={4} />
          <OtherPositionInputField
            type="text"
            value={formFieldsValues.otheruserPosition}
            onChange={event => handleTextInputFieldChange('otheruserPosition', event)}
          />
        </>
      )}
      {formFieldsValidation.userPosition === registerFormValidationErrorType.empty && (
        <>
          <SectionDivider gap={12} />
          <FormValidationError>
            {generalStrings.registerForm.formEmptyFieldErrorText(
              generalStrings.registerForm.formUserPositionFieldLabel,
            )}
          </FormValidationError>
        </>
      )}
      {formFieldsValidation.otheruserPosition === registerFormValidationErrorType.empty && (
        <>
          <SectionDivider gap={12} />
          <FormValidationError>
            {generalStrings.registerForm.formEmptyOtherRadioButtonErrorText}
          </FormValidationError>
        </>
      )}
    </>
  );
};

UserPosition.propTypes = {
  formFieldsValues: PropTypes.shape().isRequired,
  formFieldsValidation: PropTypes.shape().isRequired,
  handleTextInputFieldChange: PropTypes.func.isRequired,
  handleRadioBtnFieldChange: PropTypes.func.isRequired,
};

export default UserPosition;
